import { useEffect, useState } from "react";
import { GetKeysAction } from "../../store/Actions/action";
import { useReduxStore } from "../../hooks/useReduxStore";

const useApiKeys = () => {
  const { getState, dispatch } = useReduxStore();
  const {
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
  } = getState("Home");
  const { apiKeysList } = getState("Item");
  const [showKeyModal, setShowKeyModal] = useState(false);
  const onClickGenerate = () => {
    setShowKeyModal(true);
  };

  useEffect(() => {
    dispatch(GetKeysAction({}));
  }, [dispatch]);

  return {
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
    apiKeysList,
    showKeyModal,
    onClickGenerate,
    setShowKeyModal,
  };
};

export default useApiKeys;
